document.addEventListener('click', (event) => {
  const choice = event.target.closest('.bitig-language-panel button[name="locale_code"]');
  if (choice) {
    const form = choice.form;
    const input = form.querySelector('input[name="locale_code"]');
    event.preventDefault();
    input.value = choice.value;
    input.disabled = false;
    // Shopify's localization endpoint reads the locale from the submitted form fields.
    form.submit();
    return;
  }
  document.querySelectorAll('.bitig-language-menu[open], .bitig-category-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.bitig-language-menu[open], .bitig-category-menu[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});
